import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import getLoadingState from '~/conclude/loading';
import {setSearchTerm} from "~/actions/ui_actions";
import {getModels, getSearchModels, getSearchTerm} from "~/stateGetter";
import SearchResultsManager from "~/ui/GlobalSearch/SearchResultsManager";
import ModelResult from "~/ui/GlobalSearch/ModelResult";
import ReactDOM from "react-dom";
import SearchMessageList from "~/ui/GlobalSearch/SearchMessageList";
import {haveSearchModelsErrored} from "~/statePresenter";
import ModelConfigCache from "~/ui/ModelDataManager/ModConfigCache";
import ScrollLock from 'react-scrolllock';
import { Heading, SpinnerInput, VStack, FlatList } from "~/native-ui"

export class GlobalSearch extends Component {
	static propTypes = {
	
	};

	input = null;


    renderModel = ({ item }) => {
        return <ModelResult modelName={item} />
    }

	renderResults = () => {
	    let { searchModelNames, trans } = this.props;

	    if(this.props.hasErrored) {
	        return null;
        }

	    if(!this.isSearchActive()) {
            return null;
        }

        if(this.props.resultCount < 1 && this.props.ready && !this.props.loading) {
	        return <Heading fontSize="lg">{trans('noItems')}</Heading>
        }

        return (
            <FlatList
                removeClippedSubviews={true}
                maxToRenderPerBatch={1}
                initialNumToRender={1}
                data={searchModelNames}
                renderItem={this.renderModel}
                keyExtractor={model => model}
            />
        );
    };

	isSearchActive() {
        return this.props.searchTerm.length > 0 && this.props.ready;
    }
        
	isLoading() {
	    let isIt = this.props.searchTerm.length > 0 && (!this.props.ready || this.props.loading);

        // console.log('GlobalSearch isLoading ', isIt);

        return isIt;
    }

    setRef = (r) => {
        if (r) {
            this.input = ReactDOM.findDOMNode(r);
        }

        if (this.props.initialFocusRef){
            this.props.initialFocusRef.current = r;
        }
    }

	render() {
	    let { trans, searchTerm, setSearchTerm } = this.props;

        const results = this.renderResults();

		return (
			<VStack>
                <ModelConfigCache />
                <SearchResultsManager />

                {/* <div className={css.searchContainer}> */}
                    <SpinnerInput 
                        loading={this.isLoading()}
                        label={trans('search')}
                        value={searchTerm}
                        // className={css.search}
                        onChange={(value) => setSearchTerm(value)}
                        ref={this.setRef}
                    ></SpinnerInput>
                {/* </div> */}

                <ScrollLock>
                    <VStack mb={15}>
                        <SearchMessageList />
                        { results }
                    </VStack>
                </ScrollLock>
			</VStack>
		);
	}
}

const RXGlobalSearch = connect(
    (state) =>  {
        let loadingState = getLoadingState(state, {
            loading: ['searchResultsLoading'],
            ready: ['searchResultsReady']
        });

        return {
            searchTerm: getSearchTerm(state),
            searchModels: getSearchModels(state),
            models: getModels(state),
            ...loadingState
        }    
    },
    (dispatch) => ({
        setSearchTerm: (searchTerm) => dispatch(setSearchTerm(searchTerm))
    }),
    ({ searchModels, models, loading, ready, ...props}, dispatchers, ownProps) => {
        let resultCount = reduce(searchModels, (accumulator, model) => {
             return accumulator+model.results.value.total;
        }, 0);
        
        let searchModelNames = keys(searchModels)
            .filter((model) => searchModels[model].results.value.total)
            .sort((a, b) => {
                let aOrder = models[a].dataModel.searchOrder,
                    bOrder = models[b].dataModel.searchOrder;
                    
                return aOrder > bOrder;
            });

        return {
            hasErrored: haveSearchModelsErrored(searchModels),
            ...ownProps, ...props, ...dispatchers,
            resultCount, loading, ready, searchModelNames
        }
    },
)(GlobalSearch);

export default RXGlobalSearch;